import * as React from 'react';
import { COLOR_A, COLOR_B, TEXTURE_A, TEXTURE_B, BACKGROUND_COLOR } from './CONSTANTS';

var cumulativeOffset = function(element) {
	var top = 0,
		left = 0;
	do {
		top += element.offsetTop || 0;
		left += element.offsetLeft || 0;
		element = element.offsetParent;
	} while (element);

	return {
		top: top,
		left: left,
	};
};

const TouchSlider = ({ defaultValue, setValue, min, max, label, pushedValue }) => {
	const [localValue, setLocalValue] = React.useState((defaultValue - min) / (max - min));
	const [isMouseDown, setMouseDown] = React.useState(false);

	if (pushedValue) {
		if (pushedValue != localValue) {
			setLocalValue(pushedValue);
		}
	}

	const bar = React.useRef(null);

	return (
		<div
			ref={bar}
			onMouseDown={() => setMouseDown(true)}
			onMouseUp={() => setMouseDown(false)}
			style={{
				boxSizing: 'border-box',
				background: COLOR_B,
				width: '100%',
				height: '100%',
				border: 'solid ' + BACKGROUND_COLOR,
				margin: 'auto',
				borderWidth: '2px',
			}}
			onTouchMove={e => {
				var newValue =
					(e.targetTouches[0].clientX - cumulativeOffset(bar.current).left) / bar.current.offsetWidth;
				newValue = Math.min(Math.max(newValue, 0), 1);
				setValue(min + (max - min) * newValue);
				setLocalValue(newValue);
			}}
			onMouseMove={e => {
				if (isMouseDown) {
					var newValue = (e.clientX - cumulativeOffset(bar.current).left) / bar.current.offsetWidth;
					newValue = Math.min(Math.max(newValue, 0), 1);
					setValue(min + (max - min) * newValue);
					setLocalValue(newValue);
				}
			}}
		>
			<div
				style={{
					height: '100%',
					width: localValue * 100 + '%',
					// background: ,
					background: COLOR_A,
				}}
			/>
			<div style={{ position: 'relative', top: '-90%', left: '2%', color: 'black', zIndex: 4 }}>{label}</div>
		</div>
	);
};

export default TouchSlider;
